/**
 * JHC Header — mobile nav drawer + cart count
 */
(function () {
  'use strict';

  const menuToggle = document.querySelector('[data-menu-toggle]');
  const drawer      = document.querySelector('.jhc-nav-drawer');
  const backdrop    = document.querySelector('[data-drawer-backdrop]');
  const closeBtn    = document.querySelector('[data-drawer-close]');

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    document.body.classList.add('jhc-nav-open');
    menuToggle?.setAttribute('aria-expanded', 'true');
    if (closeBtn) setTimeout(() => closeBtn.focus(), 300);
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    document.body.classList.remove('jhc-nav-open');
    menuToggle?.setAttribute('aria-expanded', 'false');
    menuToggle?.focus();
  }

  function init() {
    if (!drawer) return;
    menuToggle?.addEventListener('click', openDrawer);
    closeBtn?.addEventListener('click', closeDrawer);
    backdrop?.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
    });

    // Mobile accordion dropdown (e.g. "Offerings")
    drawer.querySelectorAll('[data-drawer-dropdown-toggle]').forEach((toggle) => {
      toggle.addEventListener('click', () => {
        const item = toggle.closest('[data-drawer-dropdown]');
        if (!item) return;
        const isOpen = item.classList.contains('is-open');
        item.classList.toggle('is-open', !isOpen);
        toggle.setAttribute('aria-expanded', String(!isOpen));
      });
    });

    // Only plain nav links close the drawer — not the dropdown toggle button
    // (the toggle button also carries the .jhc-nav-drawer__nav-link class
    // for shared styling, so it must be excluded here or every click on
    // "Offerings" would both expand the accordion AND close the whole drawer)
    drawer.querySelectorAll('.jhc-nav-drawer__nav-link:not(.jhc-nav-drawer__nav-link--toggle)').forEach((link) => {
      link.addEventListener('click', closeDrawer);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();